
export class QuestionListDto {

   listId;
   prevId;
   code;
   name;
   active;
   program;
   personCreating;
   dateCreated;
   modifyingPerson;
   modificationDate;
   blocksInList = [];
   controls = [];
   documents = [];

}


















